// extracted by mini-css-extract-plugin
export default {"hobbies_side_bar__list":"_HobbiesSideBarNav_hobbies_side_bar__list__PuC5w","hobbies_side_bar__list--item":"_HobbiesSideBarNav_hobbies_side_bar__list--item__ympDb"};